import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import SearchIcon from '@mui/icons-material/Search';
import {
  Button,
  Tab, Tabs, Tooltip,
} from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Pagination from '@mui/material/Pagination';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import { DataGrid } from '@mui/x-data-grid';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import getLanguages from '../../../api/oc_product/product/languages/gets/getLanguages';
import deleteAttribute from '../../../api/oc_product/productDataManagement/attributes/delete/deleteAttribute';
import getAttributeCount from '../../../api/oc_product/productDataManagement/attributes/get/getAttributeCount';
import getAttributeDataTypes from '../../../api/oc_product/productDataManagement/attributes/get/getAttributeDataTypes';
import getFaciaProductCount from '../../../api/oc_product/productDataManagement/attributes/get/getFaciaProductCount';
import getSimilarLanguageSites from '../../../api/oc_product/productDataManagement/attributes/get/getSimilarLanguageSites';
import postAttributeLogs from '../../../api/oc_product/productDataManagement/attributes/post/postAttributeLogs';
import postAttributes from '../../../api/oc_product/productDataManagement/attributes/post/postAttributes';
import Modal from '../../../components/Modal';
import { AttributeDefinitionsContext } from './AttributeDefinitionsContext';
import Attributes from './Attributes';
import AttributesDefHeader from './AttributesDefHeader';
import AttributeLogs from './components/logs/AttributeLogs';
import CreateModal from './components/modals/CreateModal';
import EditModal from './components/modals/EditModal';

function TabPanel({
  children,
  value,
  index,
  ...other
}) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.defaultProps = {
  children: {},
  index: 0,
  value: 0,
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number,
  value: PropTypes.number,
};
function CustomPagination(
  selectedPage,
  onChangeSelectedPage,
  pageSize,
  onChangePageSize,
  pageAmount,
) {
  return (
    <div className="flex justify-end gap-4">
      <FormControl sx={{ m: 1, minWidth: 120 }} variant="standard" size="small" className="flex flex-row items-center mt-5 mb-0 sm:mt-0">
        <Typography variant="body2" className="mr-5">Rows per page:</Typography>
        <Select
          value={pageSize}
          onChange={onChangePageSize}
          autoWidth
          size="small"
          variant="standard"
        >
          <MenuItem value={15}>15</MenuItem>
          <MenuItem value={30}>30</MenuItem>
          <MenuItem value={50}>50</MenuItem>
          <MenuItem value={100}>100</MenuItem>
          <MenuItem value={200}>200</MenuItem>
          <MenuItem value={400}>400</MenuItem>
          <MenuItem value={600}>600</MenuItem>
          <MenuItem value={800}>800</MenuItem>
          <MenuItem value={1000}>1000</MenuItem>
        </Select>
      </FormControl>
      <Pagination
        count={pageAmount}
        page={selectedPage}
        onChange={onChangeSelectedPage}
        size="small"
      />
    </div>
  );
}

function AttributeDefinitions() {
  const [tabValue, setTabValue] = useState(0);

  const [openCreate, setOpenCreate] = useState(false);
  const [tabIndex, setTabIndex] = React.useState(0);
  const languageId = useSelector((state) => state.user.loginResponse?.selectedSite?.LanguageId);
  const siteId = useSelector((state) => state.user.loginResponse?.selectedSite?.SiteId);
  const selectedSite = useSelector((state) => state.user?.loginResponse?.selectedSite);
  const [rows, setRows] = useState([]);
  const [faciaProductRows, setFaciaProductRows] = useState([]);
  const [selectedPage, setSelectedPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [pageAmount, setPageAmount] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [deleteRow, setDeleteRow] = React.useState(null);
  const [openModal, setOpenModal] = React.useState(false);
  const [openFaciaModal, setOpenFaciaModal] = React.useState(false);
  const [deleteLoading, setDeleteLoading] = React.useState(false);
  const [faciaProductCountLoading, setFaciaProductCountLoading] = React.useState(false);
  const [fetchDataLoading, setFetchDataLoading] = React.useState(false);
  const [globalAttrCount, setGlobalAttrCount] = React.useState(0);
  const [localAttrCount, setLocalAttrCount] = React.useState(0);
  const [siteOptions, setSiteOptions] = React.useState([]);
  const [filterOpen, setFilterOpen] = useState(true);
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [languageOptions, setLanguagesOptions] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [defKeyType, setDefKeyType] = useState('name');
  const [id, setId] = useState('');
  const [idError, setIdError] = useState(false);
  const [dataType, setDataType] = useState(null);
  const [name, setName] = useState('');
  const [attributeDataTypes, setAttributeDataTypes] = useState([]);
  const [readOnly, setReadOnly] = useState(null);
  const [hidden, setHidden] = useState(false);
  const [mandatory, setMandatory] = useState(null);
  const [includeInSearchKeywords, setIncludeInSearchKeywords] = useState(null);
  const [defaultValue, setDefaultValue] = useState(null);
  const [globalVal, setGlobalVal] = useState(null);
  const [includeProductCount, setIncludeProductCount] = useState(false);
  const [includeCountCol, setIncludeCountCol] = useState(false);
  const [reRenderLogs, setReRenderLogs] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [uniqueCount, setUniqueCount] = useState('');
  // logs
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [userName, setUserName] = useState(''.toLowerCase());
  const [attributeName, setAttributeName] = useState('');
  const [defKey, setDefKey] = useState('');
  const [logs, setLogs] = useState([]);
  const [totalPages, setTotalPages] = useState();
  const [logSearchKeyWord, setLogSearchKeyWord] = useState('');
  const [logsFrom, setlogsFrom] = useState(null);
  const [logsTo, setlogsTo] = useState(null);
  const [filtersReset, setFiltersReset] = useState(false);

  const tabs = ['Attributes', 'Hidden', 'Logs'];

  const defLang = languageOptions.find((obj) => obj.LanguageId === languageId);

  const useStyles = makeStyles({
    indicator: {
      backgroundColor: '#199fb1 !important', // secondary color
      height: '4px !important',
    },
    selected: {
      color: '#fff !important',
      opacity: '1 !important',
    },
    tabRoot: {
      color: '#fff !important',
      width: '33%',
    },
    table: {
      '& .MuiTableCell-root': {
        paddingTop: '6px',
        paddingBottom: '6px',
      },
    },
    cell: {
      borderRight: '1px solid rgba(224, 224, 224, 1)',
      '&:last-child': {
        borderRight: 'none',
      },
      '&.MuiTableCell-head': {
        backgroundColor: '#fafafa', // grey[100]
      },
      width: '70%',
      '&:first-child': {
        width: '30%',
      },
    },
  });

  const styles = useStyles();

  const handleTabChange = (event, newValue) => {
    setRows([]);
    setSelectedPage(1);
    setRowsPerPage(15);
    setPageAmount(0);
    setTotalRows(0);
    setTabValue(newValue);
    setTabIndex(newValue);
  };

  const fetchData = async () => {
    setFetchDataLoading(true);
    if (includeProductCount) {
      setIncludeCountCol(true);
    } else {
      setIncludeCountCol(false);
    }

    try {
      const attributeDefId = (id === '' || !id) ? null : Number(id);

      // Apply tab-specific filters here
      const tabFilters = {};
      if (tabIndex === 0) tabFilters.isHidden = false;
      if (tabIndex === 1) tabFilters.isHidden = true;
      const hiddenRows = tabIndex === 1;
      const res = await postAttributes(
        selectedPage,
        rowsPerPage,
        siteId,
        selectedSite.LanguageId,
        name,
        attributeDefId,
        readOnly,
        hiddenRows,
        mandatory,
        includeInSearchKeywords,
        defaultValue,
        selectedSite.SiteCode === 'OC' ? true : globalVal,
        dataType?.AttributeDataTypeId,
        includeProductCount,
      );

      if (res) {
        setRows(res.data?.Data);
        setTotalRows(res.data?.Pagination.TotalCount);
        setPageAmount(res.data?.Pagination.PageCount);
      }
    } catch (error) {
      console.error('Error fetching attribute definitions:', error);
    } finally {
      setFetchDataLoading(false);
    }
  };

  const fetchAttributeDataTypes = async () => {
    try {
      const res = await getAttributeDataTypes();
      setAttributeDataTypes(res.data);
    } catch (error) {
      console.error('Error fetching attribute data types:', error);
    }
  };

  const handleGetSites = async () => {
    try {
      const res = await getSimilarLanguageSites(languageId);
      if (res) {
        setSiteOptions(res.data);
      }
    } catch (error) {
      console.error('Error fetching sites:', error);
    }
  };

  const onChangePageSize = (event) => {
    const newItemsPerPage = event.target.value;
    const newPageCount = Math.ceil(totalRows / newItemsPerPage);
    const newPage = Math.min(selectedPage, newPageCount);
    setRowsPerPage(newItemsPerPage);
    setSelectedPage(newPage);
  };

  const onChangeSelectedPage = (event, newPage) => {
    setSelectedPage(newPage);
  };

  const handleProductCountClick = async (params) => {
    try {
      setFaciaProductCountLoading(true);
      const result = await getFaciaProductCount(params.ProductAttributeDefId, params.IsSingleLine);
      setFaciaProductRows(result?.data);
    } catch (error) {
      console.error(error);
      toast.error('Failed to fetch facia product count info');
    } finally {
      setFaciaProductCountLoading(false);
    }
  };

  const resetAllFilters = () => {
    setId('');
    setDataType(null);
    setName('');
    setReadOnly(null);
    setHidden(null);
    setMandatory(null);
    setIncludeInSearchKeywords(null);
    setDefaultValue(null);
    setGlobalVal(null);
    setIncludeProductCount(false);
    setUserName('');
    setAttributeName('');
    setDefKey('');
    setLogSearchKeyWord('');
    setlogsFrom(null);
    setlogsTo(null);
  };

  const openEditModal = (data) => {
    setSelectedRow(data);
    setOpenEdit(true);
  };

  const handleModalClose = () => {
    setOpenModal(false);
  };
  // logs
  const fetchLogs = async () => {
    const logsData = await postAttributeLogs(
      logSearchKeyWord,
      defKeyType,
      logsFrom,
      logsTo,
      currentPage,
      itemsPerPage,
    );

    setLogs(logsData.data.Data);
    setTotalPages(logsData.data.Pagination.PageCount);
    setTotalRows(logsData.data.Summary.TotalRowCount);
    setReRenderLogs(false);
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };
  const handleChangeItemsPerPage = (event) => {
    const newItemsPerPage = event.target.value;
    const newPageCount = Math.ceil(totalRows / newItemsPerPage);
    const newPage = Math.min(currentPage, newPageCount);
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(newPage);
  };
  const handleDelete = async () => {
    try {
      setDeleteLoading(true);
      await deleteAttribute(deleteRow?.ProductAttributeDefId);
      toast.success(`${deleteRow?.ProductAttributeDefKey} successfully deleted`);
    } catch (error) {
      console.error(error);
      toast.error('Failed to delete attribute');
    } finally {
      getAttributeCount(siteId).then((res) => {
        setGlobalAttrCount(res.data.GlobalAttributesCount);
        setLocalAttrCount(res.data.LocalAttributesCount);
      });
      setOpenFaciaModal(false);
      setDeleteLoading(false);
      setReRenderLogs(true);
      fetchData();
      fetchLogs();
      setOpenModal(false);
    }
  };
  React.useEffect(() => {
    if (userName.length > 0) {
      setUserName('');
    }
    fetchLogs();
  }, [siteId, currentPage, itemsPerPage, rows]);
  // end logs

  React.useEffect(() => {
    if (tabIndex === 0) {
      setGlobalVal(null);
      setReadOnly(null);
      setMandatory(null);
      setDefaultValue(null);
      setIncludeInSearchKeywords(null);
    } else if (tabIndex === 1) {
      setReadOnly(null);
      setGlobalVal(null);
      setMandatory(null);
      setDefaultValue(null);
      setIncludeInSearchKeywords(null);
    } else if (tabIndex === 2) {
      setMandatory(null);
      setGlobalVal(null);
      setReadOnly(null);
      setDefaultValue(null);
      setIncludeInSearchKeywords(null);
      resetAllFilters();
      setlogsFrom(null);
      setlogsTo(null);
    }
  }, [tabIndex]);

  React.useEffect(() => {
    setTabIndex(0);
    getLanguages(siteId).then((res) => setLanguagesOptions(res.data));
    fetchData();
    fetchAttributeDataTypes();
    getAttributeCount(siteId).then((res) => {
      setGlobalAttrCount(res.data.GlobalAttributesCount);
      setLocalAttrCount(res.data.LocalAttributesCount);
    });
    resetAllFilters();
  }, [siteId, globalAttrCount, localAttrCount]);

  React.useEffect(() => {
    if (languageId && languageOptions.length > 0) {
      setSelectedLanguage(languageOptions.find((obj) => obj.LanguageId === languageId));
    }
    if (languageId) {
      handleGetSites();
    }
  }, [languageId, languageOptions]);

  React.useEffect(() => {
    fetchData();
  }, [selectedPage, rowsPerPage]);

  React.useEffect(() => {
    resetAllFilters();
    setFiltersReset(true);
  }, [tabIndex]);

  React.useEffect(() => {
    if (filtersReset) {
      fetchData();
      setFiltersReset(false);
    }
  }, [filtersReset]);

  function a11yProps(index) {
    return {
      id: `scrollable-auto-tab-${index}`,
      'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
  }
  const columns = [
    {
      field: 'ProductAttributeDefId',
      headerName: 'ID',
      flex: 1,
      minWidth: 80,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'ProductAttributeDefKey',
      headerName: 'Definition Key',
      flex: 1,
      minWidth: 150,
      align: 'center',
      headerAlign: 'center',
    },
    defLang?.LanguageName !== 'English' && {
      field: 'LocalName',
      headerName: `${defLang ? `${defLang.LanguageName} Name` : 'Local Name'}`,
      flex: 1,
      minWidth: 150,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'EnglishName',
      headerName: `${defLang?.LanguageName === 'English' ? 'Name' : 'English Name'}`,
      flex: 1,
      minWidth: 150,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'DataType',
      headerName: 'Data Type',
      flex: 1,
      minWidth: 120,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'Created',
      headerName: 'Created Date',
      flex: 1,
      minWidth: 100,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        const dateSplit = (params.value).split('T');
        return (
          <Stack direction="column">
            <p>{dateSplit[0].split('-').reverse().join('/')}</p>
            <p>{dateSplit[1].split('.')[0]}</p>
          </Stack>
        );
      },
    },
    {
      field: 'Updated',
      headerName: 'Updated Date',
      flex: 1,
      minWidth: 100,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        const dateSplit = (params.value).split('T');
        return (
          <Stack direction="column">
            <p>{dateSplit[0].split('-').reverse().join('/')}</p>
            <p>{dateSplit[1].split('.')[0]}</p>
          </Stack>
        );
      },
    },
    includeCountCol && {
      field: 'TotalUsageCount',
      headerName: 'Product Count',
      flex: 1,
      minWidth: 40,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Tooltip title="Click to view more info">
          <Button
            variant="text"
            className={`${params.value === 0 ? 'text-red-600' : 'text-green-600'}`}
            onClick={(event) => {
              event.stopPropagation();
              if (params.value === 0) return;
              setOpenFaciaModal(true);
              setModalTitle(params.row.ProductAttributeDefKey);
              setUniqueCount(params.row.TotalUsageCount);
              handleProductCountClick(params.row);
            }}
          >
            {params.value}
          </Button>
        </Tooltip>
      ),
    },
    {
      field: 'IsGlobal',
      headerName: 'Global',
      minWidth: 80,
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        params.value ? (
          <CheckCircleIcon className="text-success-600" />
        ) : (
          <CancelIcon className="text-error-600" />
        )
      ),
    },
    {
      field: 'IsReadOnly',
      headerName: 'Read Only',
      minWidth: 80,
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      headerClassName: 'white-header',
      renderCell: (params) => (
        params.value ? (
          <CheckCircleIcon className="text-success-600" />
        ) : (
          <CancelIcon className="text-error-600" />
        )
      ),
    },
    {
      field: 'IsMandatory',
      headerName: 'Mandatory',
      minWidth: 80,
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        params.value ? (
          <CheckCircleIcon className="text-success-600" />
        ) : (
          <CancelIcon className="text-error-600" />
        )
      ),
    },
    {
      field: 'IncludeInSearchKeywords',
      headerName: 'Include In Search Keywords',
      minWidth: 80,
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        params.value ? (
          <CheckCircleIcon className="text-success-600" />
        ) : (
          <CancelIcon className="text-error-600" />
        )
      ),
    },
    {
      field: 'DefaultValue',
      headerName: 'Default Value',
      minWidth: 80,
      flex: 1,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'search',
      headerName: 'Search',
      maxWidth: 80,
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <SearchIcon
          sx={{
            cursor: 'pointer',
            '&:hover': {
              color: 'green',
            },
          }}
          onClick={() => {
            const { ProductAttributeDefId, DataTypeId } = params.row;
            const productAttributeDataTypeName = attributeDataTypes.find((obj) => obj.AttributeDataTypeId === DataTypeId)?.Name;
            const url = `/product-info/products?pageSize=15&page=1&languageId=${languageId}`
              + `&productAttributeDefId=${ProductAttributeDefId}&dataTypeId=${DataTypeId}`
              + `&productAttributeDataTypeName=${productAttributeDataTypeName}`;
            window.open(url, '_blank');
          }}
        />
      ),
    },
    {
      field: 'delete',
      headerName: 'Delete',
      maxWidth: 80,
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <DeleteForeverIcon
          sx={{
            cursor: 'pointer',
            '&:hover': {
              color: 'red',
            },
          }}
          onClick={(event) => {
            event.stopPropagation();
            setOpenModal(true);
            setDeleteRow(params.row);
          }}
        />
      ),
    },
  ].filter(Boolean);

  const columnsFaciaProduct = [
    {
      field: 'Facia',
      headerName: 'Facia',
      flex: 1,
      minWidth: 80,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'ProductCount',
      headerName: 'ProductCount',
      flex: 1,
      minWidth: 150,
      align: 'center',
      headerAlign: 'center',
    }];

  const contextValue = React.useMemo(() => ({
    siteOptions,
    selectedRow,
    languageOptions,
    selectedLanguage,
    setSelectedLanguage,
    filterOpen,
    setFilterOpen,
    defKeyType,
    setDefKeyType,
    id,
    setId,
    idError,
    setIdError,
    dataType,
    setDataType,
    name,
    setName,
    attributeDataTypes,
    readOnly,
    setReadOnly,
    hidden,
    setHidden,
    mandatory,
    includeInSearchKeywords,
    setIncludeInSearchKeywords,
    setMandatory,
    defaultValue,
    setDefaultValue,
    globalVal,
    setGlobalVal,
    resetAllFilters,
    fetchData,
    fetchLogs,
    includeProductCount,
    setIncludeProductCount,
    reRenderLogs,
    setReRenderLogs,
    userName,
    setUserName,
    attributeName,
    setAttributeName,
    defKey,
    setDefKey,
    logSearchKeyWord,
    setLogSearchKeyWord,
    logsFrom,
    setlogsFrom,
    logsTo,
    setlogsTo,
  }), [
    languageOptions,
    selectedLanguage,
    filterOpen,
    setFilterOpen,
    defKeyType,
    id,
    setId,
    idError,
    setIdError,
    dataType,
    setDataType,
    name,
    setName,
    attributeDataTypes,
    readOnly,
    setReadOnly,
    hidden,
    setHidden,
    mandatory,
    setMandatory,
    defaultValue,
    setDefaultValue,
    globalVal,
    setGlobalVal,
    resetAllFilters,
    fetchData,
    fetchLogs,
    includeProductCount,
    setIncludeProductCount,
    reRenderLogs,
    setReRenderLogs,
    logSearchKeyWord,
    setLogSearchKeyWord,
    logsFrom,
    setlogsFrom,
    logsTo,
    setlogsTo]);

  return (
    <AttributeDefinitionsContext.Provider value={contextValue}>
      <div className="pt-4 md:p-8">
        <Box
          sx={{
            paddingLeft: '16px',
            paddingRight: '16px',
          }}
        >
          {/* Modals */}
          <CreateModal
            open={openCreate}
            onClose={setOpenCreate}
            attributeDataTypes={attributeDataTypes}
            fetchData={fetchData}
            setGlobalAttrCount={setGlobalAttrCount}
            setLocalAttrCount={setLocalAttrCount}
          />
          <EditModal open={openEdit} onClose={setOpenEdit} attributeDataTypes={attributeDataTypes} fetchData={fetchData} />
          <AttributesDefHeader globalAttrCount={globalAttrCount} localAttrCount={localAttrCount} setOpenCreate={setOpenCreate} tabIndex={tabIndex} />
        </Box>
        <Box sx={{
          px: 2, width: '100%', ml: 2,
        }}
        >
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            classes={{
              indicator: styles.indicator,
              root: styles.selected,
            }}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            className="flex flex-row"
            sx={{
              borderTopLeftRadius: '16px',
              borderTopRightRadius: '16px',
              overflow: 'hidden',
              position: 'sticky',
              top: 0,
              zIndex: 1000,
              backgroundColor: '#384451',
              px: 2,
            }}
          >
            {tabs.map((tab) => (
              <Tab
                {...a11yProps(tabValue)}
                key={tab}
                label={tab}
                classes={{
                  root: styles.tabRoot,
                  selected: styles.selected,
                }}
                sx={{ maxWidth: 'none' }}
              />
            ))}
          </Tabs>
          <TabPanel value={tabValue} index={0}>
            {fetchDataLoading ? (
              <div className="flex items-center justify-center h-16">
                <CircularProgress color="primary" />
              </div>
            )
              : (
                <Attributes
                  columns={columns}
                  rows={rows}
                  onChangePageSize={onChangePageSize}
                  rowsPerPage={rowsPerPage}
                  pageAmount={pageAmount}
                  totalRows={totalRows}
                  CustomPagination={CustomPagination}
                  onChangeSelectedPage={onChangeSelectedPage}
                  openEditModal={openEditModal}
                  selectedPage={selectedPage}
                  setSelectedPage={setSelectedPage}
                />
              )}
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            {fetchDataLoading ? (
              <div className="flex items-center justify-center h-16">
                <CircularProgress color="primary" />
              </div>
            )
              : (
                <Attributes
                  columns={columns}
                  rows={rows}
                  onChangePageSize={onChangePageSize}
                  rowsPerPage={rowsPerPage}
                  pageAmount={pageAmount}
                  totalRows={totalRows}
                  CustomPagination={CustomPagination}
                  onChangeSelectedPage={onChangeSelectedPage}
                  openEditModal={openEditModal}
                  selectedPage={selectedPage}
                  setSelectedPage={setSelectedPage}
                />
              )}
          </TabPanel>
          <TabPanel value={tabValue} index={2}>
            <AttributeLogs
              logs={logs}
              handleChangePage={handleChangePage}
              handleChangeItemsPerPage={handleChangeItemsPerPage}
              totalPages={totalPages}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
            />
          </TabPanel>
        </Box>

        {/* Delete Modal */}
        <Modal
          title="Delete Attribute"
          open={openModal}
          onClose={handleModalClose}
          buttonLabel="Confirm"
          buttonOnClick={handleDelete}
        >
          {deleteLoading ? (
            <div className="flex items-center justify-center h-16">
              <CircularProgress color="primary" />
            </div>
          ) : (
            <Typography className="text-center">
              {`Are you sure you want to delete ${deleteRow?.ProductAttributeDefKey}`}
            </Typography>
          )}
        </Modal>

        {/* Product Count Modal */}
        <Modal
          title={(
            <div className="text-center">
              <div className="mb-1 text-lg font-semibold">{modalTitle || 'Product Count'}</div>
              <div className="text-sm text-gray-600">
                Total Unique Products :&nbsp;
                {uniqueCount}
              </div>
            </div>
          )}
          open={openFaciaModal}
          onClose={() => setOpenFaciaModal(false)}
          desktopModalWidth="40%"
          desktopModalPadding="1rem"
          desktopModalHeight="75vh"
        >
          {faciaProductCountLoading ? (
            <div className="flex items-center justify-center h-16">
              <CircularProgress color="primary" />
            </div>
          ) : (
            <div style={{ height: '60vh', width: '100%' }}>
              <DataGrid
                rows={faciaProductRows}
                columns={columnsFaciaProduct}
                getRowId={(row) => row.Facia}
                hideFooter
              />
            </div>
          )}
        </Modal>

      </div>
    </AttributeDefinitionsContext.Provider>
  );
}

export default AttributeDefinitions;
